import Div from '@ui/layout/Div'
import Foot from '@ui/layout/Foot'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { ROLE_PUBLIC } from '@router/Routes'
import Link from '@ui/elements/Link'
import Icon from '@ui/elements/Icon'
import useHtmlRenderer from '@hook/useHtmlRenderer'

const Footer = () => {
  const { mission } = useSelector(state => state.main)
  const { externalLink, responsibleEmail, responsiblePhone } = mission
  const [t] = useTranslation('common')
  const renderHtml = useHtmlRenderer()

  const renderPhones = () => {
    return responsiblePhone.split(',').map(phone => {
      return (
        <Link link={`tel:${phone}`} ariaLabel={t('labels.header_call_us')} key={`call-us-${phone}`}>
          <Icon spanClass='link-header' icon='icon-call' label={phone} />
        </Link>
      )
    })
  }

  return (
    <Foot>
      <Div cssClass='footer-content container'>
        <Div cssClass='external-link'>
          {renderHtml(externalLink)}
        </Div>

        <Div cssClass='contact-mairie'>
          {responsibleEmail
            ? <Link link={`mailto:${responsibleEmail}`} ariaLabel={t('labels.footer_email_us')}>
              <Icon spanClass='link-header' icon='icon-mail_outline' label={t('labels.footer_email_us')} />
            </Link>
            : <></>
          }
          {responsiblePhone
            ? renderPhones()
            : <></>
          }
        </Div>
        <p>
          <a href={ROLE_PUBLIC['privacyPage']} area-label={t('labels.privacy_policy')}>{t('labels.privacy_policy')}</a>
        </p>
        <p className='rights'>
          {t('labels.all_rights_reserved', { year: new Date().getFullYear() })} <a href='https://agenceweb.fr'><strong>Agenceweb.fr</strong></a>
        </p>
      </Div>
    </Foot>
  )
}

export default Footer